// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.change-request-view-scene .content-header .data-container .left-data {
  flex: 1 1 auto;
  min-width: 0;
}
.change-request-view-scene .content-header .data-container .right-data:empty {
  display: none;
}
.change-request-view-scene .back-link {
  margin-bottom: 20px;
  border: 0;
  background: transparent;
  color: #2d5ab9;
  font-weight: 700;
  cursor: pointer;
}
.change-request-view-scene .request-summary {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 16px;
  padding: 8px 0 16px;
  border-top: 1px solid #909090;
  border-bottom: 1px solid #909090;
}
.change-request-view-scene .review-note {
  margin: 24px 0;
}
.change-request-view-scene .review-actions {
  width: fit-content;
  padding: 16px;
  margin-bottom: 24px;
  background: #f1f1f1;
}
.change-request-view-scene .review-actions-title {
  margin-bottom: 16px;
  font-size: 32px;
  font-weight: 700;
}
.change-request-view-scene .review-actions-buttons {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  align-items: center;
}
.change-request-view-scene .view-original-link {
  color: #2d5ab9;
  font-weight: 700;
}
.change-request-view-scene .work-title {
  margin-bottom: 24px;
  color: #1d4b7b;
}`, "",{"version":3,"sources":["webpack://./src/kit/scenes/RightsholderScene/ChangeRequests/View/index.scss"],"names":[],"mappings":"AAGM;EACE,cAAA;EACA,YAAA;AAFR;AAKM;EACE,aAAA;AAHR;AAQE;EACE,mBAAA;EACA,SAAA;EACA,uBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AANJ;AASE;EACE,aAAA;EACA,qCAAA;EACA,SAAA;EACA,mBAAA;EACA,6BAAA;EACA,gCAAA;AAPJ;AAUE;EACE,cAAA;AARJ;AAWE;EACE,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AATJ;AAYE;EACE,mBAAA;EACA,eAAA;EACA,gBAAA;AAVJ;AAaE;EACE,aAAA;EACA,eAAA;EACA,SAAA;EACA,mBAAA;AAXJ;AAcE;EACE,cAAA;EACA,gBAAA;AAZJ;AAeE;EACE,mBAAA;EACA,cAAA;AAbJ","sourcesContent":[".change-request-view-scene {\n  .content-header {\n    .data-container {\n      .left-data {\n        flex: 1 1 auto;\n        min-width: 0;\n      }\n\n      .right-data:empty {\n        display: none;\n      }\n    }\n  }\n\n  .back-link {\n    margin-bottom: 20px;\n    border: 0;\n    background: transparent;\n    color: #2d5ab9;\n    font-weight: 700;\n    cursor: pointer;\n  }\n\n  .request-summary {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 16px;\n    padding: 8px 0 16px;\n    border-top: 1px solid #909090;\n    border-bottom: 1px solid #909090;\n  }\n\n  .review-note {\n    margin: 24px 0;\n  }\n\n  .review-actions {\n    width: fit-content;\n    padding: 16px;\n    margin-bottom: 24px;\n    background: #f1f1f1;\n  }\n\n  .review-actions-title {\n    margin-bottom: 16px;\n    font-size: 32px;\n    font-weight: 700;\n  }\n\n  .review-actions-buttons {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    align-items: center;\n  }\n\n  .view-original-link {\n    color: #2d5ab9;\n    font-weight: 700;\n  }\n\n  .work-title {\n    margin-bottom: 24px;\n    color: #1d4b7b;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
